<div class="horizontal-center-container py-5">
  <div>
    <div class="d-flex justify-content-center">
      <!-- <lottie-player
        src="https://res.cloudinary.com/dichgutd0/image/upload/v1736225984/EL-Core-Assets/Static/Attendance/Animation-1726721660334_elaopo.gif"
        background="transparent"
        speed="1"
        style="width: 200px; height: 150px"
        loop
        autoplay
        alt="no-results"
      ></lottie-player> -->
      <img
        src="https://res.cloudinary.com/dichgutd0/image/upload/v1736225984/EL-Core-Assets/Static/Attendance/Animation-1726721660334_elaopo.gif"
        style="width: 200px; height: 200px"
        alt="Fallback Image"
        onerror="this.style.display='none';"
      />
    </div>
    <div>
      <h6 class="title flex-center text-center">
        {{ title || 'shared.processing-data.title' | translate }}
      </h6>
      <p *ngIf="!disableDescription" class="flex-center text-center">
        {{ description || 'shared.processing-data.description' | translate }}
      </p>
    </div>
  </div>
</div>
